import "./Page.css";
import Component from "react-pure-render/component";
import Button from "../components/Button.react";
import React from "react";

export default class Logout extends Component {
  static propTypes = {
    history: React.PropTypes.object
  };

  redirectToLogin = () => {
    const { history } = this.props;
    history.pushState(null, "/");
  };

  render() {
    return (
      <div className="auth-page row center-xs middle-xs">
        <div className="background" />
        <div className="auth-box">
          <h1>Fluct</h1>
          <h4>Zostałeś poprawnie wylogowany</h4>
          <Button
            info
            onClick={this.redirectToLogin}
            text="Zaloguj się ponownie"
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/auth/Logout.react.js